import * as React from 'react';
export const perplexitySvg = React.forwardRef(function perplexitySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#20808D',
      style: {
        fill: 'light-dark(#20808d,#1fb8cd)',
      },
      fillRule: 'evenodd',
      d: 'M26 11.187h-2.748V4l-6.696 6.435V4h-1.112v6.435L8.748 4v7.187H6v10.355h2.74V28l6.704-6.154V28h1.112v-6.154L23.26 28v-6.458H26zm-3.867-4.536v4.544H17.41zm-12.273 0 4.722 4.544H9.86zM7.112 20.395v-8.053h7.455L8.74 17.865v2.53H7.112m2.74-2.028 5.592-5.296v7.24L9.853 25.44zM22.14 25.44l-5.591-5.129v-7.24l5.591 5.296zm2.74-5.045h-1.62v-2.53l-5.827-5.523h7.455v8.053z',
      clipRule: 'evenodd',
    }),
  );
});
perplexitySvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '32',
  height: '32',
  fill: 'none',
  viewBox: '0 0 32 32',
};
export var perplexity = {
  category: 'brand',
  colorable: false,
  name: 'perplexity',
  svg: perplexitySvg,
};
